import type { Session } from '../models/session'
import type { SessionDto } from '../../data/dto/session.dto.ts'

export const mapSessionDtoToSession = (dto: SessionDto): Session => ({
  sessionId: dto.sessionId,
  sessionName: dto.sessionName,
  audioformId: dto.audioformId,
  projectId: dto.projectId,
  workflowId: dto.workflowId,
  state: dto.state ?? {},
})
